import { getCurrentImagesCdnService } from './configuration';

export default function getProxifiedUrl(sourceUrl) {
  const { getUrl } = getCurrentImagesCdnService();

  return getUrl(sourceUrl);
}
